import React from 'react'
import PrevixLogo from '../../assets/images/PrevixLogoTextHorizontal.svg'
import { Button } from '../../components/common/Button'
import {
  ButtonContainer,
  ContactSection,
  Container,
  Content,
  Lane,
  Link,
  LoginFooter,
  LoginImage,
  LogoImage,
  MainContent,
  Text,
} from './styles'

export const Welcome = () => {
  return (
    <Container>
      <Content>
        <LogoImage src={PrevixLogo} />
        <MainContent>
          <ButtonContainer>
            <Button.Root
              backgroundColor="#150D49"
              onClick={() => (window.location.href = '/login')}
            >
              <Button.Content title="Fazer login" />
            </Button.Root>
          </ButtonContainer>
          <Lane>
            <div></div>
            <span>ou</span>
          </Lane>
          <ContactSection>
            <Text>Não tem conta? venha conhecer nossos planos:</Text>
            <Link href="/contato">Entre em contato</Link>
          </ContactSection>
        </MainContent>
        <LoginFooter>2023 - Powered by Ubicuacloud ©</LoginFooter>
      </Content>
      <LoginImage />
    </Container>
  )
}
